import {
    AtualizarCategoriaAtendimentoService,
    DeletarCategoriaAtendimentoService,
    DesvincularModuloCategoriaAtendimentoService,
    GetCategoriaAtendimentoService,
    InserirCategoriaAtendimentoService,
    ListarCategoriaAtendimentoArvorePorTipoCasoService,
    ListarCategoriaAtendimentoArvoreService,
    ListarCategoriaAtendimentoFilhosService,
    ListarCategoriaAtendimentoPaiService,
    ListarCategoriaAtendimentoService,
    ListarCategoriaAtendimentosService,
    ListarCategoriasDeAtendimentoPorCasoService,
    ListarModulosVinculadosPorCategoriaService,
    VincularModuloCategoriaAtendimentoService,
} from "../../../Services/Geral/CategoriaAtendimento/CategoriaAtendimentoServices";

import {
    ICategoriaAtendimento,
    IModuloCategoriaAtendimento,
} from "../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";
import { Controller } from "../../Controller";

export async function GetCategoriaAtendimentoController(
    idCategoriaAtendimento: number
) {
    return Controller(GetCategoriaAtendimentoService(idCategoriaAtendimento));
}

export async function ListarCategoriaAtendimentoPaiController(
    ID_TIPO_CASO: number
) {
    return Controller(ListarCategoriaAtendimentoPaiService(ID_TIPO_CASO));
}

export async function ListarCategoriaAtendimentoController(
    ID_TIPO_CASO: number
) {
    return Controller(ListarCategoriaAtendimentoService(ID_TIPO_CASO));
}

export async function ListarCategoriaAtendimentoArvorePorTipoCasoController(
    ID_TIPO_CASO: number
) {
    return Controller(
        ListarCategoriaAtendimentoArvorePorTipoCasoService(ID_TIPO_CASO)
    );
}

export async function ListarCategoriaAtendimentoArvoreController(
    idTipoCaso: number
) {
    return Controller(ListarCategoriaAtendimentoArvoreService(idTipoCaso));
}

export async function ListarCategoriaAtendimentosController() {
    return Controller(ListarCategoriaAtendimentosService());
}

export async function ListarCategoriaAtendimentoFilhosController(
    idCategoriaAtendimentoPai: number
) {
    return Controller(
        ListarCategoriaAtendimentoFilhosService(idCategoriaAtendimentoPai)
    );
}

export async function AtualizarCategoriaAtendimentoController(
    requestBody: ICategoriaAtendimento
) {
    return Controller(AtualizarCategoriaAtendimentoService(requestBody));
}

export async function DeletarCategoriaAtendimentoController(
    ID_CATEGORIA_ATENDIMENTO: number
) {
    return Controller(
        DeletarCategoriaAtendimentoService(ID_CATEGORIA_ATENDIMENTO),
        "Categoria de Atendimento deletada com sucesso!"
    );
}

export async function InserirCategoriaAtendimentoController(
    requestBody: ICategoriaAtendimento
) {
    return Controller(
        InserirCategoriaAtendimentoService(requestBody),
        "Categoria de Atendimento cadastrada com sucesso!"
    );
}

export async function ListarModulosVinculadosPorCategoriaController(
    ID_CATEGORIA_ATENDIMENTO: number
) {
    return Controller(
        ListarModulosVinculadosPorCategoriaService(ID_CATEGORIA_ATENDIMENTO)
    );
}

export async function VincularModuloCategoriaAtendimentoController(
    requestBody: IModuloCategoriaAtendimento
) {
    return Controller(
        VincularModuloCategoriaAtendimentoService(requestBody),
        (res) => (res ? "Módulo vinculado com sucesso!" : "")
    );
}

export async function DesvincularModuloCategoriaAtendimentoController(
    ID_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) {
    return Controller(
        DesvincularModuloCategoriaAtendimentoService(
            ID_CATEGORIA_ATENDIMENTO_TIPO_CASO
        ),
        "Módulo desvinculado com sucesso!"
    );
}

export async function ListarCategoriasDeAtendimentoPorCasoController(
    idCaso: number
) {
    return Controller(ListarCategoriasDeAtendimentoPorCasoService(idCaso));
}
